import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shards-react'
import '../../invite-accept-screen.css'

export default function InvalidTokenMessage({ goToLoginPage }) {
    InvalidTokenMessage.propTypes = {
        goToLoginPage: PropTypes.func,
    }

    return (
        <Fragment>
            <i
                className="material-icons invite-accept--icon--disapproved"
                style={{
                    fontSize: 75,
                }}
            >
                cancel
            </i>
            <p>Olá.</p>
            <p>Infelizmente, você não pode participar no projeto porque o seu token não está válido.</p>
            <Button id="invite-accept--back-button" onClick={goToLoginPage}>
                Acessar o portal
            </Button>
        </Fragment>
    )
}
